import { call, put, takeLatest } from "@redux-saga/core/effects";
import { request } from "../../../apiConfig/api";
import {
  getFleetTripFailure,
  getFleetTripSuccess,
  getDeviceUserMappingFailure,
  getDeviceUserMappingSuccess,
  getDeviceUsersSuccess,
  getDeviceUsersFailure,
} from "./action";
import {
  GET_FLEET_TRIP,
  GET_DEVICE_USER_MAPPING,
  GET_DEVICE_USERS,
} from "./actionTypes";

export function* getFleetTrip(payload: any): Generator {
  const { clientId, ecode, tripStartDateTime, tripEndDateTime } = payload?.payload;
  const queryString =`clientId=${clientId}&ecode=${ecode}&tripStartTime=${tripStartDateTime}&tripEndTime=${tripEndDateTime}`;

  try {
    const result: any = yield call(request, {
      url: `trip?${queryString}`,
      method: "GET",
    });

    yield put(getFleetTripSuccess(result));
  
  } catch (error) {
    yield put(getFleetTripFailure(error));
  }
}

export function* getDeviceUserMapping(payload: any): Generator {
  const { size, page } = payload?.payload;
  try {
    const result: any = yield call(request, {
      url: `users/platform/api/deviceUserMapping?size=${size}&page=${page}`,
      method: "GET",
    });
    yield put(getDeviceUserMappingSuccess(result));
  } catch (error) {
    yield put(getDeviceUserMappingFailure(error));
  }
}

export function* getDeviceUsers(payload: any): Generator {
  const { size, page } = payload?.payload;
  try {
    const result: any = yield call(request, {
      url: `users/platform/api/vw_userDtl?size=${size}&page=${page}`,
      method: "GET",
    });
    yield put(getDeviceUsersSuccess(result));
  } catch (error) {
    yield put(getDeviceUsersFailure(error));
  }
}

function* tripsSaga() {
  yield takeLatest(GET_FLEET_TRIP, getFleetTrip);
  yield takeLatest(GET_DEVICE_USER_MAPPING, getDeviceUserMapping);
  yield takeLatest(GET_DEVICE_USERS, getDeviceUsers);
}

export default tripsSaga;
